import React from 'react';
import arrowLeftBlack from '../../../assets/arrowLeftBlack.svg';
import arrowLeftWhite from '../../../assets/arrowLeftWhite.svg';
import {
  AbsoluteHeaderBackArrowImg,
  AbsoluteHeaderLogoWrapper,
  AbsoluteHeaderLogo,
  AbsoluteHeaderWrapper,
} from './AbsoluteHeader.styled';
import blackLogo from '../../../assets/blackLogo.png';
import whiteLogo from '../../../assets/whiteLogo.png';

interface AbsoluteHeaderProps {
  onBack?: () => void;
  color?: 'black' | 'white';
  withLogoOnMobileDisplay?: boolean;
  logoColor?: 'black' | 'white';
}

export const AbsoluteHeader: React.FC<AbsoluteHeaderProps> = ({
  color = 'black',
  onBack,
  withLogoOnMobileDisplay = false,
  logoColor = 'black',
}) => {
  const arrowLeft = color === 'black' ? arrowLeftBlack : arrowLeftWhite;

  return (
    <AbsoluteHeaderWrapper>
      {onBack ? <AbsoluteHeaderBackArrowImg alt="←" src={arrowLeft} onClick={onBack} /> : null}
      <AbsoluteHeaderLogoWrapper>
        {withLogoOnMobileDisplay ? (
          <AbsoluteHeaderLogo src={logoColor === 'white' ? whiteLogo : blackLogo} alt="CirclesLogo" />
        ) : null}
      </AbsoluteHeaderLogoWrapper>
    </AbsoluteHeaderWrapper>
  );
};
